import { Editor } from 'grapesjs';
import { faUsersCrown } from '@fortawesome/pro-solid-svg-icons/faUsersCrown';
import { EditorComponentDefinition } from '../types';
import { LeaderboardTableGrapesComponent } from './leaderboard-v2-table-grapes-component';
import { Toolbar } from '../../utils';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';

export const leaderboardV2ComponentDefinition: EditorComponentDefinition = {
  id: 'leaderboard-v2',
  icon: faUsersCrown,
  category: 'Gamification',
  getLabel: ({ t }) => t('editor.component.leaderboard'),
  component: LeaderboardGrapesComponent,
  copyPasteHelper: markChildrenWithParentType,
};

export function LeaderboardGrapesComponent(editor: Editor) {
  LeaderboardTableGrapesComponent(editor);

  const languages = editor.Config?.context?.languages || [];

  editor.DomComponents.addType(leaderboardV2ComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains('qlfeditor-leaderboard');
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.leaderboard.title',
                        { l: language },
                      )}</h1>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: 'leaderboard-v2-table',
          },
        ],
        attributes: {
          class: 'qlfeditor-leaderboard',
          tagName: 'section',
          'aria-label': 'aria.leaderboard.label',
          'aria-description': 'aria.leaderboard.description',
        },
        traits: [],
        droppable: false,
        draggable: '[data-gjs-type=column]',
      },
      initToolbar: Toolbar,
    },
  });
}
